module.exports = __webpack_public_path__ + "static/hollywood-00904cdadf808b4aace307cd37acf7a3.jpg";